<template><KnowledgeWorkspace editorial :editor-component="TextEditor" :project="project" :send="send" :article-id="$route.params.id" :source-visit="$route.query.visit" :create-on-open="$route.query.create === '1'" @open="open" @list="list" @all="all" @visit="visit" /></template>
<script>
import TextEditor from '@/components/Knowledge/TextEditor.vue';
import KnowledgeWorkspace from '@/components/Knowledge/Workspace.vue';
export default {
  name: 'AdminKnowledge', components: { KnowledgeWorkspace },
  computed: { TextEditor() { return TextEditor; }, project() { return this.$STORE.state.userConfig.setProjectId; } },
  methods: {
    send(method, path, body, project) { const url = '/core/api/knowledge/' + path + (path.includes('?') ? '&' : '?') + 'p=' + encodeURIComponent(project); return method === 'get' ? this.$ApiServiceLayer.get(url, '') : this.$ApiServiceLayer.post(url, '', body); },
    open(id) { this.$router.push({ name: 'knowledgeArticle', params: { id }, query: this.$route.query.visit ? { visit: this.$route.query.visit } : {} }).catch(() => {}); },
    list() { this.$router.push({ name: 'knowledge', query: this.$route.query.visit ? { visit: this.$route.query.visit } : {} }).catch(() => {}); },
    all() { this.$router.push({ name: 'knowledge' }).catch(() => {}); },
    visit(id) { this.$router.push('/visitmanagment/answerlist/' + id).catch(() => {}); },
  },
};
</script>
